import { useEffect } from 'react'
import { useRecoilValue, useSetRecoilState } from 'recoil'
import { DEFAULT_PIS } from 'src/config'
import { atomCurrentStep, atomIsPisAlive, atomPaymentData, atomPisPaymentId } from 'src/storage'

export const BeforeUnloadRoot = () => {
  const isPisDefault = DEFAULT_PIS
  const isPisAlive = useRecoilValue(atomIsPisAlive)
  const pisPaymentId = useRecoilValue(atomPisPaymentId)
  const currentStep = useRecoilValue(atomCurrentStep)
  const setPaymentData = useSetRecoilState(atomPaymentData)

  useEffect(() => {
    // Detect if the page is reloaded
    sessionStorage.setItem('isReloading', 'false')

    const handleBeforeUnload = () => {
      const isReloading = sessionStorage.getItem('isReloading') === 'true'
      if (
        !isReloading &&
        (!isPisDefault || !isPisAlive) &&
        currentStep === 4 &&
        pisPaymentId === undefined
      ) {
        // Reset state only if: not a refresh, PIS is not default or not alive, not in step 4 and is not a PIS payment
        setPaymentData(undefined)
      }
    }

    const topWindow = window.top ?? window

    topWindow.addEventListener('beforeunload', handleBeforeUnload)

    return () => {
      topWindow.removeEventListener('beforeunload', handleBeforeUnload)
    }
  }, [])

  return <></>
}
